import { type SearchParams, withSearchParams } from '@ui/util/url';
import { generatePath } from 'react-router';

import type { RouteItem } from './types';

export function path(
  route: RouteItem | string,
  params?: Record<string, string | number>,
  query?: SearchParams,
): string {
  let path = '';

  if (typeof route === 'object') {
    path = route.path;
  } else {
    path = route;
  }

  // Convert param values to strings.
  const pathParams = params
    ? Object.fromEntries(
        Object.entries(params).map(([key, value]) => [key, String(value)]),
      )
    : undefined;

  if (query) {
    return withSearchParams(generatePath(path, pathParams), query);
  }

  return generatePath(path, pathParams);
}

export function sitePath(
  siteCode: string,
  route: RouteItem | string,
  params: Record<string, string | number> = {},
  query?: SearchParams,
): string {
  return path(route, { ...params, siteCode: siteCode.toLowerCase() }, query);
}

export function teamPath(
  teamCode: string,
  route: RouteItem | string,
  params: Record<string, string | number> = {},
  query?: SearchParams,
): string {
  return path(route, { ...params, teamCode: teamCode.toLowerCase() }, query);
}
